export default __webpack_public_path__ + "static/media/inTouchCircle.c0bedaaf.png";